module.exports = __webpack_public_path__ + "img/newsletter-background@2x.ef80620e.jpg";